module.exports = __webpack_public_path__ + "static/media/deal_sent.c817c082.png";